import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  HStack,
  Text,
  useDisclosure,
  useTheme,
} from "@chakra-ui/react";
import { FaCheck } from "react-icons/fa";
import { FiList } from "react-icons/fi";

const optionsMap = Object.freeze({
  NONE: "None",
  questionGroup: "Question Group",
  stage: "Stage",
  owner: "Owner",
});

const GroupByComponent = ({ groupBy, setGroupBy }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [selected, setSelected] = useState(groupBy);

  const isActive = selected !== "NONE";

  const { colors } = useTheme();

  const handleApply = () => {
    onClose();
    setGroupBy(selected);
  };

  return (
    <Box>
      <Button
        variant="primary"
        borderRadius="full"
        onClick={onOpen}
        color={isActive ? "pureWhite" : "pureBlack"}
        bg={isActive ? "teal" : "gray.100"}
        fontSize="body.xs"
        rightIcon={<FiList color={colors.limeShade[600]} />}
        size="sm"
      >
        Group by {isActive ? `: ${optionsMap[selected]}` : ""}
      </Button>

      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bg="gray.50" borderColor="gray.200">
          <DrawerCloseButton />
          <DrawerHeader fontSize="heading.m" color="gray.600">
            Group by
          </DrawerHeader>
          <DrawerBody>
            <Box p={0} m={0} borderRadius="lg" color="gray.100">
              {Object.keys(optionsMap).map((option) => (
                <HStack
                  key={option}
                  justify="space-between"
                  py={3}
                  px={4}
                  borderWidth="1px 0px 1px 0px"
                  borderColor="gray.200"
                  cursor="pointer"
                  onClick={() => setSelected(option)}
                >
                  <Text
                    fontWeight={selected === option ? "bold" : "normal"}
                    color={selected === option ? "teal" : "gray.500"}
                  >
                    {optionsMap[option]}
                  </Text>
                  {selected === option && <FaCheck color="limegreen" />}
                </HStack>
              ))}
            </Box>
          </DrawerBody>
          <DrawerFooter>
            <Button mt={4} variant="primary" onClick={() => handleApply()}>
              Apply
            </Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default GroupByComponent;
